import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getArrayToRecordsTourSteps({
	defaultStyles,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	return [
		{
			id: 'collection-field',
			selector: '[data-tour="collection-field"]',
			content:
				'Required: Set the target object to split into separate records. This target object should be an array in the processing data.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
